<template>
    <div class='player-box'>
        <transition name="move" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CottonMainBox'
});
</script>

<style scoped lang='css'>

</style>